module.exports = __webpack_public_path__ + "img/search.18297f89.svg";